import React, { useEffect } from "react"
import { useTableContext } from "../../provider"
import { getLocalStorageValues, TableLocalStorageKey } from "../../helpers"

export const InitializerFilters = () => {

  const ctx = useTableContext()
  const { tableId, defaultFilters } = ctx.props

  useEffect(() => {
    const filters = getLocalStorageValues(tableId, TableLocalStorageKey.filters) || {}
    ctx.filters.api.setValues({ ...defaultFilters || {}, ...filters || {} })
    ctx.lifecycle.increment()
  }, [])

  return (<></>)
}
